var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMemberAdd = function SvgMemberAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "member_add_svg__st0",
    d: "M12 18.51c0-1.49.51-2.87 1.36-3.97-1.54-.55-2.23-1.34-1.25-3.14C16.05 4.12 13.23-.01 9-.01c-4.15 0-7.04 3.97-3.11 11.4 1.29 2.44-.38 3.02-3.25 3.68C-.22 15.74 0 17.26 0 20.01h12.18c-.11-.49-.18-.98-.18-1.5zM18.5 13.01c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5 5.5-2.46 5.5-5.5-2.46-5.5-5.5-5.5zm2.75 4.12-.52.52-.34.34-2.51 2.51-.34.34-1.58.48c-.16.03-.3-.11-.27-.27l.48-1.58.34-.34 2.51-2.51.02.02.32-.36.52-.52c.09-.09.23-.09.32 0l1.05 1.05c.09.09.09.22 0 .32z"
  })));
};
export default SvgMemberAdd;